export default __webpack_public_path__ + "static/fi-fb2342cb621ca14e40f895e49eebac67.svg";